import React from 'react';
import PropTypes from 'prop-types';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import Checkbox from '@material-ui/core/Checkbox';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import isDefined from '@afosto/utils/isDefined';
import * as defaultFormatters from './formatters';

const DataGridRows = ({ formatters: providedFormatters }) => {
  const {
    data,
    activeItem: activeItemModule = {},
    dataProperties = {},
    hasModule,
    selection = {},
  } = useDataSourceContext();
  const { getActiveProperties } = dataProperties;
  const { activeItem, setActiveItem } = activeItemModule;
  const { isItemSelected, toggleItemSelection } = selection;
  const hasSelectionModule = hasModule('selection');
  const hasActiveItemModule = hasModule('activeItem');
  const formatters = { ...defaultFormatters, ...providedFormatters };

  /**
   * Handle a click on a cell in the data grid.
   * @param {string} cell
   * @param {Object} row
   */
  const handleCellClick = (cell, row) => () => {
    if (hasActiveItemModule) {
      setActiveItem(activeItem !== row.id ? row.id : null);
    }
  };

  /**
   * Return the grid row elements.
   * @returns {array}
   */
  const getGridRows = () =>
    data.map(row => {
      const cells = getActiveProperties().map(
        ({ key, type, formatOptions = {}, align = 'left', padding = 'default' }) => {
          const cell = row[key];
          let format = type;

          if (!formatters[format] && Array.isArray(cell)) {
            format = 'array';
          } else if (!type && typeof cell === 'boolean') {
            format = 'boolean';
          }

          const cellValue = isDefined(cell) ? cell : '-';

          return (
            <TableCell
              key={`row-${key}`}
              align={align}
              onClick={handleCellClick(cell, row)}
              padding={padding}
            >
              {format && formatters[format]
                ? formatters[format](cell, row, formatOptions)
                : cellValue}
            </TableCell>
          );
        },
      );

      const rowActive = hasActiveItemModule && activeItem === row.id;

      return (
        <TableRow key={row.id} selected={rowActive} hover={hasActiveItemModule}>
          {hasSelectionModule && (
            <TableCell key="checkbox" padding="checkbox">
              <Checkbox
                checked={isItemSelected(row.id)}
                onChange={() => toggleItemSelection(row.id)}
              />
            </TableCell>
          )}
          {cells}
        </TableRow>
      );
    });

  return <TableBody>{getGridRows()}</TableBody>;
};

DataGridRows.propTypes = {
  formatters: PropTypes.object,
};

DataGridRows.defaultProps = {
  formatters: {},
};

export default DataGridRows;
